export default class Dom {

  /**
   * Get all the previous and next siblings, optionally filtered by a selector
   */
  static getSiblings(element, filter) {
    var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var siblings = [];
    var currentElement = element;

    // Do the previous first
    while (currentElement = currentElement.previousElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    }

    // Then the next side
    currentElement = element;

    while (currentElement = currentElement.nextElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  /**
   * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
   * we need to normalize it
   */

  static nodeListToArray(nodeList, filter) {
    var items = [];

    for (var i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }

  /**
   * Calculate an element width with its margin
   */

  static outerWidthWithMargin(element) {
    var width = element.offsetWidth,
        style = getComputedStyle(element);

    width += parseInt(style.marginLeft) + parseInt(style.marginRight);

    return width;
  }

  /**
   * Calculate an element height with its margin
   */

  static outerHeightWithMargin(element) {
    var height = element.offsetHeight,
        style = getComputedStyle(element);

    height += parseInt(style.marginTop) + parseInt(style.marginBottom);

    return height;
  }
}